import { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType } from 'swiper';

import 'swiper/css';
import { cn } from '@/shared/lib/utils';
import TransparentArrowButton from '@/shared/ui/buttons/TransparentArrowButton';

export interface IImageSliderProps {
    images: Array<string>;
    className?: string;
}

export function ImageSlider({ images, className }: IImageSliderProps) {
    const swiperRef = useRef<SwiperType | null>(null);
    const [winWidth, setWinWidth] = useState(0);
    const [currentSlideIndex, setCurrentSlideIndex] = useState(0)


    let canLoop = false;
    
    if(winWidth <= 768 && images.length >= 3)
       canLoop  = true;
    else if(winWidth <= 1440 && images.length >= 6)
       canLoop  = true;
    else if(winWidth <= 1920 && images.length >= 8)
       canLoop  = true;

    const handleSwiperNext = () => {
        swiperRef.current?.slideNext();
    };

    const handleSwiperPrev = () => {
        swiperRef.current?.slidePrev();
    };

    useEffect(()=>{
        const handleResize = () => setWinWidth(window.innerWidth);
    
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [])

    return (
        <div className={cn('w-full h-fit overflow-hidden relative', className)}>

            <TransparentArrowButton
                className="absolute z-10 left-[10px] md:left-[32px] lg:left-[150px] xl:left-[200px] top-1/2 -translate-y-1/2"
                arrow='left'
                onClick={handleSwiperPrev}
            />

            <TransparentArrowButton
                className="absolute z-10 right-[10px] md:right-[32px] lg:right-[150px] xl:right-[200px] top-1/2 -translate-y-1/2"
                arrow='right'
                onClick={handleSwiperNext}
            />

            <Swiper
                centeredSlides={canLoop}
                direction="horizontal"
                loop={canLoop}
                slidesPerView="auto"
                pagination={{ clickable: true }}
                className="mySwiper h-auto"
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
                onSlideChange={(swiper)=>{
                    setCurrentSlideIndex(swiper.realIndex);
                }}  
            >
                {images.map((item, index) => (
                    <SwiperSlide
                        key={index}
                        className='max-w-[300px] min-h-[300px] md:max-w-[400px] md:min-h-[400px] overflow-hidden'
                    >
                        <img
                            className={cn(
                                'h-[300px] min-h-[300px] md:max-w-[400px] md:min-h-[400px] object-cover zoom-image',
                                winWidth <= 768 && currentSlideIndex == index && 'scale-[1.15]'
                            )}
                            src={item}
                            alt=''
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
